import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import axios from 'axios'

import {LunaModal} from '../widgets/lunamodal.component'

export class ItineraryTitleButtons extends React.Component {
    constructor(props) {
        super(props)

        this._isMounted = false

        this.state = {
            showModal: false,
            statusModal: null,
            hasPwdError: false,
        }

        _.bindAll(this,
            'showModal',
            'onModalHide',
            'checkPwdStrength',
            'pwdMatch',
            'onSavePassword'
        )
    }

    componentDidMount() {
        this._isMounted = true
    }

    showModal(evt) {
        this.setState({
            showModal: true,
            statusModal: null
        })
    }

    onModalHide() {
        this.setState({
            showModal: false
        })
    }

    checkPwdStrength() {
        let curPwd = this.refs.password_1.value
        let error_mssg = ''

        // check length
        if (curPwd.length < 8) {
            error_mssg += 'Password must be at least 8 characters'
        } else if (curPwd.match(/\d+/g) == null) {
            error_mssg += 'Password must contain at least 1 number.'
        } else {
            // check for upper/lower
            // check case
            let upper = 0
            let lower = 0
            for (var i = 0; i < curPwd.length; i++) {
                // check to makes sure it's not a number
                if (!(!isNaN(parseFloat(curPwd[i])) && isFinite(curPwd[i]))) {
                    if (curPwd[i] === curPwd[i].toUpperCase()) {
                        upper++
                    } else {
                        lower++
                    }
                }
            }
            if (upper == 0 || lower == 0) {
                error_mssg += 'Password must contain at least one uppercase and one lowercase letter.'
            }
        }

        if (error_mssg !== '') {
            this.setState({hasPwdError: true})
            this.refs.password_btn.className = 'btn btn-medium disabled'
        }
        this.refs.password_1_error.innerHTML = error_mssg
        this.pwdMatch()
    }

    pwdMatch() {
        let pwd1 = this.refs.password_1.value
        let pwd2 = this.refs.password_2.value
        if (pwd2.length > 0) {
            if (pwd1 !== pwd2) {
                this.refs.password_2_success.innerHTML = ''
                this.refs.password_2_error.innerHTML = 'Passwords do not match'
                this.refs.password_btn.className = 'btn btn-medium disabled'
                this.setState({hasPwdError: true})
            } else {
                this.refs.password_2_success.innerHTML = 'Passwords Match'
                this.refs.password_2_error.innerHTML = ''
                this.refs.password_btn.className = 'btn btn-medium btn-blue'
                this.setState({hasPwdError: false})
            }
        } else {
            this.refs.password_2_success.innerHTML = ''
            this.refs.password_2_error.innerHTML = ''
            this.refs.password_btn.className = 'btn btn-medium disabled'
            this.setState({hasPwdError: true})
        }
    }

    getTitleButtons() {
        const bookingLink = `/bookings/${this.props.tripGuid}/itinerary/${this.props.itineraryGuid}/`
        if (this.props.isLunaTrip) {
            let lunaLink = '/create-trip?luna-slug=' + this.props.lunatrip.get('slug')
            return (
                <div className="itinerary-top-buttons">
                    <a href={lunaLink} className="btn btn-rose">Make This Your Trip</a>
                </div>
            )
        } else {
            let userBtn = <a href="/logout">Log Out</a>
            let modal = null
            if (!this.props.currentUser.has_password || window.payload.isGuest) {
                if (!this.props.currentUser.has_password) {
                    if (window._isMobile) {
                        userBtn =  <i onClick={this.showModal} className="icon-profile"/>
                    } else {
                        userBtn =  <a onClick={this.showModal} className="btn btn-blue">Create Account</a>
                    }
                    modal = <LunaModal statusModal={ this.state.statusModal } onModalHide={ this.onModalHide } showModal={ this.state.showModal } modalContent={this.modalContent()}/>
                } else {
                    userBtn = <a href="/login" className="btn btn-blue">Log In</a>
                    modal = <LunaModal statusModal={ this.state.statusModal } onModalHide={ this.onModalHide } showModal={ this.state.showModal } modalContent={this.modalContent()}/>
                }
            }
            let bookBtn = <a href={bookingLink} className="btn">Book Now</a>
            if (window._isMobile) {
                bookBtn = null
            }
            return (
                <div className="itinerary-top-buttons">
                    {modal}
                    {bookBtn}
                    {userBtn}
                </div>
            )
        }
    }

    modalContent() {
        if (!this.props.currentUser.has_password || window.payload.isGuest) {
            if (!this.props.currentUser.has_password) {
                return (
                    <div className="modal-content">
                        <i className="icon-close" onClick={ this.onModalHide }/>
                        <h1>Create Password</h1>
                        <p>Looks like you already have an account, set a passord to be able to login.</p>
                        <div ref="entryform" className="modal-form">

                            <div className="form-group input-plain">
                                <label htmlFor="password_1">Password</label>
                                <input
                    id="password_1"
                    type="password"
                    name="password_1"
                    className="form-control input-medium"
                    ref="password_1"
                    onChange={() => {this.checkPwdStrength()}}/>
                                <div className="error red" ref="password_1_error"/>
                            </div>
                            <div className="form-group input-plain">
                                <label htmlFor="password_2">Confirm Password</label>
                                <input
                    id="password_2"
                    type="password"
                    name="password_2"
                    className="form-control input-medium"
                    ref="password_2"
                    onChange={() => {this.pwdMatch()}}/>
                                <div className="error red" ref="password_2_error"/>
                                <div className="green" ref="password_2_success"/>
                            </div>
                            <button ref="password_btn" className="btn btn-medium disabled" onClick={ this.onSavePassword }>Save</button>
                        </div>
                    </div>
                )
            }
        }
    }

    onSavePassword() {
        let self = this
        if (this.props.currentUser && this.refs.password_1.value) {
            let cEmail = this.props.currentUser.traveler_email
            let cPass = this.refs.password_1.value

            this.refs.entryform.classList.add('disabled')
            axios.post('/api/v1/travelers/' + this.props.currentUser.guid + '/password', {
                password: self.refs.password_1.value
            }).then(function(response) {
                if (typeof response.data != 'undefined') {
                    let data = response.data.data
                    if (self._isMounted) {
                        self.setState({statusModal: 'success'})
                        axios.post('/login', {
                            email: cEmail,
                            password: cPass,
                            redirect_to: window.location.href
                        }).then(function(response) {
                            console.log(response)
                            if (typeof response.data != 'undefined') {
                                let data = response.data.data
                                if (self._isMounted) {
                                    console.log('assuming we redirect?')
                                    location.reload()
                                    // TODO: make call to login/ with email, password, and redirect to with current page url to refresh page
                                    // this.refs.entry_form.classList.remove('disabled')
                                }
                            } else {
                                self.setState({statusModal: 'error'})
                                // this.refs.entry_form.classList.remove('disabled')
                            }
                        })

                        // this.refs.entry_form.classList.remove('disabled')
                    }
                } else {
                    self.setState({statusModal: 'error'})
                    // this.refs.entry_form.classList.remove('disabled')
                }
            })
        }
    }

    render() {
        return (
            <div className="itinerary-top-buttons-wrapper">
                { this.getTitleButtons() }
            </div>
        )
    }
}
